import React from 'react';
import {
  AlertBanner,
  type AlertBannerColorTheme,
} from '@saviynt/design-system';

import { ALERT_BANNER_DEFAULT } from '../../constants';

import { useFormContext } from './hooks';

import './FormAlertBanner.css';

/**
 * FormAlertBanner
 */
function FormAlertBanner() {
  const { alertBanner, setAlertBanner } = useFormContext();

  return (
    <AlertBanner
      colorTheme={alertBanner.kind as AlertBannerColorTheme}
      title={alertBanner.title}
      description={alertBanner.description}
      shouldAutoDismiss
      isVisible={alertBanner.isOpen}
      dataTestId='savi-copilot-form-alert-banner'
      className='FormAlertBanner'
      onCancel={() => {
        setAlertBanner({
          ...ALERT_BANNER_DEFAULT,
          kind: alertBanner.kind,
          isOpen: false,
        });
      }}
    />
  );
}

export default FormAlertBanner;
